export enum DashboardCalendarItemWidthSizeNames {
    XXLarge = "XXLarge",
    XLarge = "XLarge",
    LARGE = "Large",
    MEDIUM = "Medium",
    SMALL = "Small",
    TINY = "Tiny",
}

export enum DashboardCalendarItemHeightSizeNames {
    SMALL = "Small",
    MEDIUM = "Medium",
    LARGE = "Large",
}

export const DashboardCalendarItemWidthBreakpoints = {
    [DashboardCalendarItemWidthSizeNames.XXLarge]: 1084,
    [DashboardCalendarItemWidthSizeNames.XLarge]: 544,
    [DashboardCalendarItemWidthSizeNames.LARGE]: 272,
    [DashboardCalendarItemWidthSizeNames.MEDIUM]: 136,
    [DashboardCalendarItemWidthSizeNames.SMALL]: 68,
    [DashboardCalendarItemWidthSizeNames.TINY]: 26,
};

export const DashboardCalendarItemHeightBreakpoints = {
    [DashboardCalendarItemHeightSizeNames.LARGE]: 140,
    [DashboardCalendarItemHeightSizeNames.MEDIUM]: 64,
    [DashboardCalendarItemHeightSizeNames.SMALL]: 30,
};

// Since we can`t rely on Window Size for DashboardCalendarItems responsive, because these components have dynamic width and height depending on event duration and items count per date,
// so to achieve required responsive for all dashboard items used these helper which check height and width of each component
export const shouldHideAllExceptImage = (width: number) => {
    if (width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.SMALL]) {
        return true;
    }

    return false;
};

export const shouldShowTime = (width: number) => {
    if (width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.SMALL]) {
        return false;
    }

    return true;
};

export const shouldShowBalance = (width: number) => {
    if (width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.MEDIUM]) {
        return false;
    }

    return true;
};

export const shouldShowBalanceTooltip = (height: number, width: number) => {
    if (
        width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.XXLarge] &&
        height < DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.MEDIUM]
    ) {
        return true;
    }

    return false;
};

export const shouldShowName = (height: number, width: number) => {
    if (
        width >= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.MEDIUM] &&
        width <= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.LARGE] &&
        height < DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.LARGE]
    ) {
        return false;
    }

    if (
        width >= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.LARGE] &&
        width <= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.XXLarge] &&
        height < DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.MEDIUM]
    ) {
        return false;
    }

    if (width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.MEDIUM]) {
        return false;
    }

    return true;
};

export const shouldShowMainInfo = (height: number, width: number) => {
    if (
        width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.LARGE] &&
        height < DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.LARGE]
    ) {
        return false;
    }

    if (width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.MEDIUM]) {
        return false;
    }

    return true;
};

export const shouldShowOnlyBalanceAndReservedCounterInMainInfo = (height: number, width: number) => {
    if (
        width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.LARGE] &&
        height < DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.MEDIUM]
    ) {
        return true;
    }

    return false;
};

export const shouldShowReservedCount = (width: number) => {
    if (width >= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.MEDIUM]) {
        return true;
    }

    return false;
};

export const shouldShowSubInfo = (height: number, width: number) => {
    if (width >= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.XLarge]) {
        return true;
    }

    if (
        width >= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.LARGE] &&
        height >= DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.LARGE]
    ) {
        return true;
    }

    return false;
};

export const shouldShowExperienceTitleInFirstRow = (height: number, width: number) => {
    if (
        width >= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.XXLarge] &&
        height <= DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.SMALL]
    ) {
        return false;
    }

    return true;
};

export const shouldShowExperienceInLastRow = (height: number) => {
    if (height >= DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.MEDIUM]) {
        return true;
    }

    return false;
};

export const shouldShowCheckedInAndVouchersSeparate = (height: number, width: number) => {
    if (
        width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.LARGE] &&
        width >= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.MEDIUM] &&
        height >= DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.LARGE]
    ) {
        return true;
    }

    return false;
};

export const shouldShowSubInfoSeparate = (height: number, width: number) => {
    if (
        width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.XLarge] &&
        width > DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.LARGE] &&
        height >= DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.LARGE]
    ) {
        return true;
    }

    return false;
};

export const shouldShowWaitlist = (width: number) => {
    if (width >= DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.LARGE]) {
        return true;
    }

    return false;
};

export const shouldShowBalanceInFirstRow = (height: number) => {
    if (height < DashboardCalendarItemHeightBreakpoints[DashboardCalendarItemHeightSizeNames.MEDIUM]) {
        return true;
    }

    return false;
};

export const shouldMainAndSubInfoToBeReversed = (width: number) => {
    if (width < DashboardCalendarItemWidthBreakpoints[DashboardCalendarItemWidthSizeNames.XLarge]) {
        return true;
    }

    return false;
};
